// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1714) return "static/chunks/1714-882009fe313bef43.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "bd7d4ef988b1eec8" + ".js";
};